import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { Observable } from 'rxjs';
import { of } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';

import { environment } from '../environments/environment';
import { AndonUser } from './andon-user';

const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};

@Injectable({
  providedIn: 'root'
})
export class AndonUserService {

  errMessage = '';

// private AndonUserUrl = environment.apiUrl + 'UserMaster/';  // Web APIのURL
// private AndonGroupUrl = 'api/andonGroup';  // Web APIのURL

  constructor(
    private http: HttpClient ) { }

  /** サーバーから取得する */
  // getAndonUsers (): Observable<AndonUser[]> {
  getAndonUsers (): Observable<AndonUser[]> {
    return this.http.get<AndonUser[]>(environment.apiUrl + 'UserMaster/List' )
      .pipe(
  //      tap(List => this.log(`fetched List`)),
        catchError(this.handleError('getAndonUser', []))
      );
  }
    /** サーバーから取得する */
    getAndonUser (userID: String, password: String) {
      return this.http.get(environment.apiUrl + 'UserMaster/1?UserID=' + userID + '&Password=' + password )
        .pipe(
      //      tap(List => this.log(`fetched List`)),
      //    catchError(this.handleError('getAndonUser', []))
        );
      }
    /*
  getAndonUser (userID: String): Observable<AndonUser[]> {
    return this.http.get<AndonUser[]>(this.AndonUserUrl + '1?UserID=' + userID )
      .pipe(
    //      tap(List => this.log(`fetched List`)),
        catchError(this.handleError('getAndonUser', []))
      );
    }
    */
   /**
   * 失敗したHttp操作を処理します。
   * アプリを持続させます。
   * @param operation - 失敗した操作の名前
   * @param result - observableな結果として返す任意の値
   */
  private handleError<T> (operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {

      // TODO: リモート上のロギング基盤にエラーを送信する
      console.error(error); // かわりにconsoleに出力

      // TODO: ユーザーへの開示のためにエラーの変換処理を改善する
      this.log(`${operation} failed: ${error.message}`);

      // 空の結果を返して、アプリを持続可能にする
      return of(result as T);
    };
  }

  /** HeroServiceのメッセージをMessageServiceを使って記録 */
  private log(message: string) {
    console.error('AndonUserService: ' + message);
    alert(this.errMessage);
  }
}
